export const blockIconsPlacesAirportShuttle = (
	<span className='material-symbols-outlined'>airport_shuttle</span>
);
